<div role="alert" class="note-banner">Note: The Law Society cannot see this information.</div>
<h2>{{competency?.Name}}</h2>
<h3>Your proficiency rating for this competency at the beginning of the CPD year was: <span class="rating">{{" " + competency?.Rating}}</span></h3>
<h3>The activities you have completed for this competency this year are:</h3>
<p class="disclaimer">If there are additional activities you have completed that aren’t listed here, you can add them in the <a [routerLink]="['/app/track-progress', competency?.PlanId]">Track Progress</a> section of the Tool. Review any notes you made on your activities to help you reflect on their effectiveness.</p>
<ul class="activity-list">
    <li *ngFor="let activity of competency?.Activities | excludeActivity; let i = index">
        <mat-card appearance="outlined">
            <div class="activity-title">{{activity.ActivityTemplate.Name}}</div>
            <div class="progress">Progress: <span class="complete">Complete</span></div>
            <p class="activity-notes">{{activity.Notes}}</p>
        </mat-card>
    </li>
    <li *ngIf="competency && (competency.Activities | excludeActivity)?.length === 0">
        <mat-card appearance="outlined">
            <p class="no-activity"><strong>No learning activities have been marked as complete for this competency.</strong></p>
        </mat-card>
    </li>
</ul>

<div class="form-wrapper">
    <form #f="ngForm">
        <h3>Use the space below to reflect on the competency</h3>
        <div>Some questions you might reflect on include:</div>
        <ul>
            <li>How, if at all, did they activities you completed this year (whether they were part of the plan you submitted or not) impact your knowledge and skills in this competency?</li>
            <li>Did you or others notice change in the way your performed this competency? If yes, describe those changes.</li>
            <li>If you did not experience a difference in this competency, were there any barriers to improving your proficiency in this area?</li>
            <li>What might you adjust for next year to make your plane more effective?</li>
        </ul>
        <mat-form-field>
            <mat-label>Your reflections on this competency</mat-label>
            <textarea [attr.aria-label]="'Your reflections on this competency: ' + competency.Name" [name]="competency?.Id" placeholder="Your reflections on this competency" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10" [maxlength]="10000" [(ngModel)]="competency.ReflectionNotes" [disabled]="finalReflectionStatus !== 'Available'" appValidateSpecialCharacter appValidatePastedSpecialCharacter></textarea>
            <div class="validation-error" *ngIf="competency && competency.ReflectionNotes?.length >= 10000">Maximum character
                limit reached.</div>
        </mat-form-field>
        <h3>Self-assess your proficiency level now that you have completed your learning activities</h3>
        <div>You can use the below performance indicators for this competency for this competency to assess whether your proficiency level has increased</div>
        <ul>
            <li>Use appropriate and current substantive and procedural law applicable to one’s own practice area(s).</li>
            <li>Accurately identify relevant facts, legal issues and informational gaps or discrepancies.</li>
            <li>Research, interpret and correctly apply common law, statutes, regulations, rules, procedure, policy and theory to a legal issue.</li>
            <li>Seek relevant expertise on a matter when needed.</li>
            <li>Prudently assess possible courses of action, by considering the range of potential outcomes and weighing the risks on each.</li>
            <li>Create legal strategy appropriate and proportionate to client needs and means.</li>
        </ul>
        <div class="middle" role="radiogroup">
            <label>
                <input type="radio" name="radio" id="pre-discovery" value="Pre-discovery" [(ngModel)]="competency.ReflectionRating" [disabled]="finalReflectionStatus !== 'Available'"/>
                <div class="box">
                    <span>Pre-discovery</span>
                    <div>Lacks awareness of the competency or its relevance to professional practice.</div>
                </div>
            </label>
            <label>
                <input type="radio" name="radio" id="discover" value="Discover" [(ngModel)]="competency.ReflectionRating" [disabled]="finalReflectionStatus !== 'Available'"/>
                <div class="box">
                    <span>Discover</span>
                    <div>Express curiosity about, develops awareness of, or learns about the competency</div>
                </div>
            </label>
            <label>
                <input type="radio" name="radio" id="attempt" value="Attempt" [(ngModel)]="competency.ReflectionRating" [disabled]="finalReflectionStatus !== 'Available'"/>
                <div class="box">
                    <span>Attempt</span>
                    <div>Tests out the competency, learns through mistakes, or engages in deliberate practice</div>
                </div>
            </label>
            <label>
                <input type="radio" name="radio" id="do" value="Do" [(ngModel)]="competency.ReflectionRating" [disabled]="finalReflectionStatus !== 'Available'"/>
                <div class="box">
                    <span>Do</span>
                    <div>Demonstrates the competency with effort, conscious attention, or occasional missteps or setbacks</div>
                </div>
            </label>
            <label>
                <input type="radio" name="radio" id="excel" value="Excel" [(ngModel)]="competency.ReflectionRating" [disabled]="finalReflectionStatus !== 'Available'"/>
                <div class="box">
                    <span>Excel</span>
                    <div>Demonstrates the competency proficiently, effortlessly, and habitually</div>
                </div>
            </label>
            <label>
                <input type="radio" name="radio" id="lead" value="Lead" [(ngModel)]="competency.ReflectionRating" [disabled]="finalReflectionStatus !== 'Available'"/>
                <div class="box">
                    <span>Lead</span>
                    <div>Models this competency for others or uses it to transform practice</div>
                </div>
            </label>
          </div>
    </form>
    <div class="principa-footer">Professional Foundations Proficiency Scale by Principia Assessments Ltd. is
        licensed
        under CC BY-NC-ND 4.0</div>
</div>
